import { render } from "./Datatable.vue?vue&type=template&id=5a21af30"
import script from "./Datatable.vue?vue&type=script&lang=js"
export * from "./Datatable.vue?vue&type=script&lang=js"

import "./Datatable.vue?vue&type=style&index=0&id=5a21af30&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/common/Datatable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5a21af30"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5a21af30', __exports__)) {
    api.reload('5a21af30', __exports__)
  }
  
  module.hot.accept("./Datatable.vue?vue&type=template&id=5a21af30", () => {
    api.rerender('5a21af30', render)
  })

}


export default __exports__